<template>
  <div class="columns is-multiline filtros-licitacoes-row">
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-2-desktop">
      <FiltroMultiSelect
        label="Situação"
        :options="situacoes"
        :value="filters.situacaoIds"
        @input="update('situacaoIds', $event)"
        @commit="commit"
        @open="$emit('open')"
        @close="$emit('close')"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-3-desktop">
      <FiltroOrgaoAutocomplete
        :show-todos-tag="false"
        :value="filters.orgaoId"
        @input="updateAndCommit('orgaoId', $event)"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-1-desktop">
      <FiltroUfAutocomplete
        :options="ufs"
        :show-todos-tag="false"
        :value="filters.uf"
        @input="updateAndCommit('uf', $event)"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-2-desktop">
      <DateRangePicker
        label="Abertura"
        date-limit="fromToday"
        dropdown-align="right"
        :value="filters.abertura"
        @input="updateAndCommit('abertura', $event)"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-2-desktop">
      <DateRangePicker
        label="Publicação"
        date-limit="untilToday"
        dropdown-align="right"
        :value="filters.publicacao"
        @input="updateAndCommit('publicacao', $event)"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-2-desktop">
      <b-field label="Nº Licitação/Processo">
        <b-input
          placeholder="Nº do processo ou da licitação"
          :value="filters.processoOuNumero"
          @input="update('processoOuNumero', $event)"
          @blur="commit"
        />
      </b-field>
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-2-desktop">
      <FiltroMultiSelect
        label="Modalidade"
        :options="modalidades"
        :value="filters.modalidades"
        @input="update('modalidades', $event)"
        @commit="commit"
        @open="$emit('open')"
        @close="$emit('close')"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-3-desktop">
      <FiltroMultiSelect
        label="Tipo de Edital"
        :options="tiposEdital"
        :value="filters.tiposEdital"
        @input="update('tiposEdital', $event)"
        @commit="commit"
        @open="$emit('open')"
        @close="$emit('close')"
      />
    </div>
    <div class="column filtros-licitacoes__campo is-12-mobile is-6-tablet is-2-desktop">
      <FiltroMultiSelect
        label="Tipo de Pregão"
        :options="tiposPregao"
        :value="filters.tiposPregao"
        @input="update('tiposPregao', $event)"
        @commit="commit"
        @open="$emit('open')"
        @close="$emit('close')"
      />
    </div>
    <div
      class="column filtros-licitacoes__campo filtros-licitacoes__campo--objeto is-12-mobile is-12-tablet is-5-desktop"
    >
      <FiltroTextoTodos
        label="Objeto"
        placeholder="Descrição do objeto"
        :show-todos-tag="false"
        :value="filters.objeto"
        @input="update('objeto', $event)"
        @blur="commit"
      />
    </div>
  </div>
</template>

<script>
import DateRangePicker from '@/components/DateRangePicker/DateRangePicker';
import FiltroMultiSelect from './FiltroMultiSelect';
import FiltroOrgaoAutocomplete from './FiltroOrgaoAutocomplete';
import FiltroTextoTodos from './FiltroTextoTodos';
import FiltroUfAutocomplete from './FiltroUfAutocomplete';

export default {
  name: 'FiltrosLicitacoesFornecedor',
  components: {
    DateRangePicker,
    FiltroMultiSelect,
    FiltroOrgaoAutocomplete,
    FiltroTextoTodos,
    FiltroUfAutocomplete,
  },
  props: {
    value: { type: Object, required: true },
    situacoes: { type: Array, required: true },
    ufs: { type: Array, required: true },
    modalidades: { type: Array, required: true },
    tiposEdital: { type: Array, required: true },
    tiposPregao: { type: Array, required: true },
  },
  computed: {
    filters() {
      return this.value;
    },
  },
  methods: {
    update(key, value) {
      this.$emit('input', { ...this.value, [key]: value });
    },
    updateAndCommit(key, value) {
      this.update(key, value);
      this.$nextTick(() => this.commit());
    },
    commit() {
      this.$emit('commit');
    },
  },
};
</script>
